import { GuideProductsSection, GuideProductsData } from './Product';
import { FaIcon } from '@ifixit/ui/components/icon';
import { cn } from '@ifixit/ui/lib/utils';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { MutableRefObject, useRef } from 'react';
import { _js } from '@ifixit/localize';

export interface ComponentData {
   productData: GuideProductsData;
   introData: GuideIntroData;
}
interface GuideIntroData {
   introHtml: string;
}

export function GuideProducts(props: ComponentData) {
   const hasIntro = Boolean(props.introData.introHtml);

   const introRef = useRef<HTMLDivElement>(undefined);

   if (!hasIntro) {
      return (
         <div className="flex flex-col-reverse sm:flex-row">
            {/* @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<HTMLDivElement | undefined>... Remove this comment to see the full error message */}
            <GuideItems hasIntro={hasIntro} {...props.productData} introRef={introRef}></GuideItems>
            <div className="flex flex-col-reverse sm:flex-col flex-1"></div>
         </div>
      );
   }

   return (
      <div className="flex flex-col">
         <div className="flex flex-col-reverse sm:flex-row">
            {/* @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<HTMLDivElement | undefined>... Remove this comment to see the full error message */}
            <GuideIntro {...props.introData} introRef={introRef}></GuideIntro>
            {/* @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<HTMLDivElement | undefined>... Remove this comment to see the full error message */}
            <GuideItems hasIntro={hasIntro} {...props.productData} introRef={introRef}></GuideItems>
         </div>
      </div>
   );
}

function GuideIntro({
   introHtml,
   introRef,
}: GuideIntroData & { introRef: MutableRefObject<HTMLDivElement> }) {
   if (!introHtml) {
      return null;
   }

   return (
      <div className="flex flex-col-reverse sm:flex-col flex-1 self-start sticky top-0">
         <div className="introduction-container prose-wiki flex flex-col m-0 py-4">
            <div className="flex flex-col-reverse sm:flex-row items-start sm:items-baseline gap-0 sm:gap-3 mb-3 sm:mb-4">
               <h2 className="flex m-0 text-[20px] sm:text-[24px] font-medium text-gray-800">
                  {_js('Introduction')}
               </h2>
               <GoToFirstStep className="m-0 pb-3 sm:pb-0" />
            </div>
            <div
               dangerouslySetInnerHTML={{ __html: introHtml }}
               ref={introRef}
               className="[&>*:first-of-type]:p-0 [&>*:first-of-type]:m-0"
            ></div>
         </div>
      </div>
   );
}

function GoToFirstStep({ className }: { className?: string }) {
   const firstStep = document.querySelectorAll('.step-title')?.[0];

   if (!firstStep) {
      return null;
   }

   const scrollToFirstStep = () => {
      trackAnalyticsCustomEvent({
         eventCategory: 'Guide Products',
         eventAction: 'Guide Products - Go to step 1',
      });
      firstStep?.scrollIntoView({ behavior: 'smooth' });
   };

   return (
      <button
         type="button"
         onClick={scrollToFirstStep}
         className={cn(
            'text-lg text-brand-500 line-clamp-1 cursor-pointer bg-transparent border-none p-0 text-left',
            className
         )}
      >
         {_js('Go to step 1') + ' '}
         <FaIcon name="arrow-down" style="regular" className="inline size-4" />
      </button>
   );
}

function GuideItems({
   hasIntro,
   tools,
   parts,
   kits,
   introRef,
}: GuideProductsData & { hasIntro: boolean; introRef: MutableRefObject<HTMLDivElement> }) {
   const hasProducts = [tools, parts, kits].reduce((sum, arr) => sum + arr.length, 0) > 0;
   if (!hasProducts) {
      return null;
   }

   return (
      <div
         className={cn(
            'flex flex-col py-4 sm:pr-0 flex-[0_1_50vw] lg:flex-[0_1_448px]',
            hasIntro ? 'sm:pl-4' : 'sm:pl-0'
         )}
      >
         {/* Translators: Heading for a list of parts and tools needed to complete a guide */}
         <h2 className="text-[20px] sm:text-[24px] font-medium text-gray-800 mt-0 mb-3 sm:mb-4">
            {_js('What you need')}
         </h2>
         <GuideProductsSection kits={kits} tools={tools} parts={parts} introRef={introRef} />
      </div>
   );
}
